import { makeStyles } from '@material-ui/core/styles';

import { complementaryColor, mainColor, minimWidthBasicButton } from '../utils/constants';

// Palete de colors aqui: https://material-ui.com/customization/palette/

const programConfigurationStyles = makeStyles((theme) => ({
  eventTable: {
    marginBottom: theme.spacing(5),    
  },
  eventTableCell0: {
    textAlign:'left',
    width: '100%',
    padding: theme.spacing(0),

  },
  eventTableCell1: {
    textAlign:'left',
    width: '20%',
    verticalAlign: 'top',    
  },
  eventTableCell2: {
    textAlign:'left',
    width: '80%',
    verticalAlign: 'top',   
  },
  nestedItem: {
    paddingLeft: theme.spacing(2),
  },
  collapsedText: {
    textAlign:'left',
    width: '50%',
  },
  collapsedRepeatText: {
    textAlign:'left',
    width: '40%',
  },
  variablesText1: {
    textAlign:'left',
    width: '30%',
  },
  variablesText2: {
    textAlign:'left',
    width: '70%',
  },
}));

export default programConfigurationStyles;
